import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { socialPublishingKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function disconnectMeta(): Promise<void> {
  await apiClient.url("/social-publishing/connection").delete().res();
}

export function useDisconnectMeta(): UseMutationResult<void, Error, void> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: disconnectMeta,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: socialPublishingKeys.all });
    },
  });
}
